"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersonasSearch = void 0;
var react_1 = require("react");
var SearchHighlight_1 = require("../../shared/components/SearchHighlight");
var constants_1 = require("../constants");
// Match only the fields the user can actually see on a persona card —
// today that's just the display name. `internalName` and `system` are
// part of the data model but never rendered in this panel, so matching
// them produced "phantom" matches the user couldn't trace.
var propertyMatchesSearch = function (property, matcher) {
    return SearchHighlight_1.textMatchesSearch(property.name, matcher);
};
/**
 * Derives all search-related view-state from the current draft schema
 * and search input. Pure derivation — no internal state — so the hook
 * is safe to share across screens that follow the categorized-items
 * pattern.
 */
exports.usePersonasSearch = function (draftSchema, searchText) {
    var searchMatcher = react_1.useMemo(function () { return SearchHighlight_1.buildSearchMatcher(searchText); }, [searchText]);
    var isSearching = searchMatcher !== null;
    var analysisByCategory = react_1.useMemo(function () {
        var analysis = {};
        draftSchema.forEach(function (category) {
            var displayedName = category.name || constants_1.PERSONAS_UNTITLED_GROUP;
            var nameMatches = SearchHighlight_1.textMatchesSearch(displayedName, searchMatcher);
            var matchingProperties = searchMatcher
                ? category.properties.filter(function (property) { return propertyMatchesSearch(property, searchMatcher); })
                : category.properties;
            var isVisible = !searchMatcher ? true : nameMatches || matchingProperties.length > 0;
            analysis[category.id] = { nameMatches: nameMatches, matchingProperties: matchingProperties, isVisible: isVisible };
        });
        return analysis;
    }, [draftSchema, searchMatcher]);
    var visibleCategories = react_1.useMemo(function () {
        return draftSchema.filter(function (category) { return (analysisByCategory[category.id] || { isVisible: true }).isVisible; });
    }, [draftSchema, analysisByCategory]);
    var hasResults = !isSearching || visibleCategories.length > 0;
    var visiblePropertiesFor = function (category) {
        if (!category) {
            return [];
        }
        if (!isSearching) {
            return category.properties;
        }
        var entry = analysisByCategory[category.id];
        return entry ? entry.matchingProperties : [];
    };
    return {
        searchText: searchText,
        searchMatcher: searchMatcher,
        isSearching: isSearching,
        analysisByCategory: analysisByCategory,
        visibleCategories: visibleCategories,
        hasResults: hasResults,
        visiblePropertiesFor: visiblePropertiesFor,
    };
};
